import React, { useState } from "react";
import {
  useStripe,
  useElements,
  PaymentElement,
} from "@stripe/react-stripe-js";
import { Checkbox } from "components/common";

const paymentElementOptions = {
  terms: {
    cashapp: "auto", // 'auto' | 'always' | 'never'
    card: "auto", // 'auto' | 'always' | 'never'
  },
  wallets: {
    googlePay: "auto", // 'always' | 'auto' | 'never'
    applePay: "auto", // 'always' | 'auto' | 'never'
  },
  fields: {
    billingDetails: {
      name: "auto",
      address: {
        line1: "auto",
        line2: "auto",
        city: "auto",
        state: "auto",
        country: "auto",
        postalCode: "auto",
      },
    },
  },
  layout: {
    type: "accordion",
    defaultCollapsed: false,
    radios: false,
    spacedAccordionItems: true,
  },
};
const checkBoxLabel = () => <span>Set as default Payment Method</span>;

const SetupForm = ({ isMobile, pastDue, onReady }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [errorMessage, setErrorMessage] = useState("");
  const [asDefault, setAsDefault] = useState(true);
  const [stripeLoaded, setStripeLoaded] = useState(false);

  const handleOnReady = () => {
    setStripeLoaded(true);
    onReady?.();
  };

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();
    setErrorMessage("");

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const addAsDefault = asDefault ? "&setDefault=true" : "";
    const { error } = await stripe.confirmSetup({
      // `Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        return_url: `${process.env.REACT_APP_DOMAIN}/dashboard/settings?section=payment-method${addAsDefault}`,
      },
    });

    if (error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)
      console.log(error);
      setErrorMessage(error.message);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
    }
  };

  return (
    <form onSubmit={handleSubmit} className={isMobile ? "flex flex-col" : ""}>
      <PaymentElement options={paymentElementOptions} onReady={handleOnReady} />
      {errorMessage && <p className="text-red-600">{errorMessage}</p>}
      {!pastDue && !!stripeLoaded && (
        <Checkbox
          boost
          labelComponent={checkBoxLabel()}
          labelClassName="text-sm mt-2 ml-1"
          checked={asDefault}
          onChange={(e) => setAsDefault(e.target.checked)}
        />
      )}
      <button
        type="submit"
        className={`btn my-4 ${
          isMobile ? "w-3/4 self-center" : ""
        } text-base bg-boost-primary-purple border-none`}
        disabled={!stripe || !stripeLoaded}
      >
        {pastDue ? "Submit Payment" : "Add Payment Method"}
      </button>
    </form>
  );
};

export default SetupForm;
